import $ from 'jquery';

export default function avuBlockCounter(counterContainerClass) {
    let containers = $(counterContainerClass).toArray();
    // Current index container
    let currentIndex = 0;

    function checkAndStartCountdown() {
        // If all counters are completed
        if (currentIndex >= containers.length) return;

        let container = $(containers[currentIndex]);
        if (isElementInViewport(container) && !container.data('counted')) {
            startCountdown(container);
        }
    }

    function isElementInViewport(el) {
        let rect = el[0].getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    function startCountdown(container) {
        // Set current counter as counted
        container.data('counted', true);
        let counterElements = container.find('.counter-module__item-0, .counter-module__item-1, .counter-module__item-2, .counter-module__item-3');

        // Calculate the maximum final value among all counters
        let maxFinalValue = Math.max(...counterElements.map(function () {
            return parseFloat($(this).find('.counter-item-number').text());
        }).get());

        // Define total time for the countdown in milliseconds
        let totalTime = 2000; // 2 seconds
        let intervalTime = 50; // Interval between updates

        counterElements.each(function () {
            let counterElement = $(this);
            let finalValue = parseFloat(counterElement.find('.counter-item-number').text());
            let currentValue = 0;
            let isDecimal = finalValue % 1 !== 0;

            // Calculate increment per interval for this counter
            let increment = (finalValue / maxFinalValue) * (maxFinalValue / (totalTime / intervalTime));

            counterElement.find('.counter-item-number').text(isDecimal ? currentValue.toFixed(2) : currentValue);

            let interval = setInterval(() => {
                if (currentValue < finalValue) {
                    currentValue += increment;
                    if (currentValue > finalValue) currentValue = finalValue;

                    counterElement.find('.counter-item-number').text(isDecimal ? currentValue.toFixed(2) : Math.round(currentValue));
                } else {
                    clearInterval(interval);

                    counterElement.find('.counter-item-number').text(isDecimal ? finalValue.toFixed(2) : Math.round(finalValue));

                    // Check if all counters in the container are completed
                    if (counterElements.index(counterElement) === counterElements.length - 1) {
                        // Count next container
                        currentIndex++;
                        // Start next counter
                        checkAndStartCountdown();
                    }
                }
            }, intervalTime);
        });
    }

    $(window).on('scroll', checkAndStartCountdown);
    checkAndStartCountdown();
}
